// src/api/urls.js
export const API_URLS = {
    ABOUT_US: '/api/v2/pages/4/',
    TEAM: '/about/team/',
    GALLERY: '/gallery/',
    CONTACT_US: '/contact/form/',
    DESTINATIONS: '/destinations/list/',
    DESTINATION_DETAILS: '/api/v2/pages',
    TESTIMONIALS: '/testimonials/',
    // DESTINATION_DETAILS: (id) => `/api/destinations/${id}`,
    BOOK_DESTINATION: '/booking/create/',
    BLOGS: '/blogs/list/',
};

export const BASE_IMAGE_URL = "https://api.ecoheartadventure.com";
  